import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const clientTagService = {
  getAllTags,
  createTag,
  updateTag,
  deleteTag,
  assignTag,
  unassignTag,
}

export function getAllTags() {
  return apiHelper(API_URL).get('/client-tags')
}

export function createTag(payload) {
  return apiHelper(API_URL).post('/client-tags', payload)
}

export function updateTag(uuid, payload) {
  return apiHelper(API_URL).put(`/client-tags/${uuid}`, payload)
}

export function deleteTag(uuid) {
  return apiHelper(API_URL).delete(`/client-tags/${uuid}`)
}

export function assignTag(debtorCode, tagUuid) {
  return apiHelper(API_URL).post(`/customers/${encodeURIComponent(debtorCode)}/tags`, { tag_uuid: tagUuid })
}

export function unassignTag(debtorCode, tagUuid) {
  return apiHelper(API_URL).delete(`/customers/${encodeURIComponent(debtorCode)}/tags/${tagUuid}`)
}
